(() => {
  const script = document.currentScript;
  const message = script?.dataset.message;
  const linkText = script?.dataset.linkText;
  const linkUrl = script?.dataset.linkUrl;
  const prewireIds = new Set([14668237439343, 14917860327791, 15435528339823]);
  const controls = '[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"], .shopify-payment-button, #dynamic-checkout-cart, .dynamic-cart-btns, shopify-accelerated-checkout-cart, [data-sticky-express], redo-shopify-toggle';
  const savedStates = new Map();
  const originalFetch = window.fetch;
  let blocked = false;
  let queued = false;
  let requestVersion = 0;
  let checkTimer;

  function isFactory47Handlebar(item) {
    return /handlebar/i.test(item.product_type || '') && /factory\s*47/i.test(item.vendor || '');
  }

  function restoreControl(element, state) {
    if (state.ariaDisabled === null) element.removeAttribute('aria-disabled');
    else element.setAttribute('aria-disabled', state.ariaDisabled);
    if (state.inert === null) element.removeAttribute('inert');
    else element.setAttribute('inert', state.inert);
    element.classList.remove('f47-checkout-unavailable');
  }

  function apply() {
    queued = false;
    savedStates.forEach((state, element) => {
      if (!blocked || !element.isConnected) {
        restoreControl(element, state);
        savedStates.delete(element);
      }
    });
    if (blocked) {
      document.querySelectorAll(controls).forEach((element) => {
        if (!savedStates.has(element)) {
          savedStates.set(element, {
            ariaDisabled: element.getAttribute('aria-disabled'),
            inert: element.getAttribute('inert')
          });
        }
        element.setAttribute('aria-disabled', 'true');
        element.classList.add('f47-checkout-unavailable');
        if (!element.matches('button, input, a')) element.setAttribute('inert', '');
      });
    }

    document.querySelectorAll('.cart__summary, .cart-drawer__summary').forEach((summary) => {
      const notes = [...summary.querySelectorAll('.f47-prewire-guard')];
      if (!blocked) {
        notes.forEach((note) => note.remove());
        return;
      }
      const button = summary.querySelector('[name="checkout"]');
      const target = summary.querySelector('.cart-drawer__checkout-buttons') || button?.parentElement;
      if (!target || !message || !linkText || !linkUrl) return;
      const note = notes.shift() || document.createElement('p');
      notes.forEach((duplicate) => duplicate.remove());
      if (!note.classList.contains('f47-prewire-guard')) {
        note.className = 'f47-prewire-guard';
        note.setAttribute('role', 'status');
        const text = document.createElement('span');
        text.textContent = message;
        const link = document.createElement('a');
        link.href = linkUrl;
        link.className = 'link';
        link.textContent = linkText;
        note.append(text, link);
      }
      if (target.previousElementSibling !== note) target.before(note);
    });
  }

  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(apply);
  }

  function updateCart(cart) {
    const items = cart.items || [];
    blocked = items.some((item) => prewireIds.has(Number(item.product_id))) &&
      !items.some(isFactory47Handlebar);
    apply();
  }

  function check() {
    const version = ++requestVersion;
    const root = window.Shopify?.routes?.root || '/';
    return originalFetch.call(window, `${root}cart.js`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then((response) => {
      if (!response.ok) throw new Error('Cart unavailable');
      return response.json();
    }).then((cart) => {
      if (version === requestVersion) updateCart(cart);
    }).catch(() => {});
  }

  function scheduleCheck() {
    clearTimeout(checkTimer);
    checkTimer = setTimeout(check, 100);
  }

  window.fetch = function (input) {
    const result = originalFetch.apply(this, arguments);
    const url = String(input?.url || input);
    if (/\/cart\/(add|change|update|clear)(?:[.?]|$)/.test(url)) {
      result.then(scheduleCheck, () => {});
    }
    return result;
  };

  ['on:cart:add', 'on:line-item:change'].forEach((eventName) => {
    document.addEventListener(eventName, (event) => {
      if (event.detail?.cart?.items) {
        requestVersion += 1;
        updateCart(event.detail.cart);
      } else {
        scheduleCheck();
      }
    });
  });
  document.addEventListener('on:cart-drawer:after-open', scheduleCheck);
  window.addEventListener('pageshow', scheduleCheck);

  function isCheckoutEvent(event) {
    return event.composedPath().some((node) => node instanceof Element && node.matches(controls));
  }

  function preventCheckout(event) {
    if (!blocked || !isCheckoutEvent(event)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }

  document.addEventListener('click', preventCheckout, true);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') preventCheckout(event);
  }, true);
  document.addEventListener('submit', (event) => {
    if (!blocked) return;
    const form = event.target;
    const submitter = event.submitter;
    if (submitter?.name === 'checkout' ||
        (!submitter && form instanceof HTMLFormElement && /\/cart\/?$/.test(new URL(form.action).pathname))) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });

  if (/\/products\/(pre-wire-handlebar-add-on|factory-47-pre-wire-option)/.test(location.pathname)) {
    const style = document.createElement('style');
    style.textContent = '.shopify-payment-button, [data-sticky-express] { display: none !important; }';
    document.head.appendChild(style);
  }

  check();
})();
